import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextProvider } from 'uitk-react-utils';
import { UitkIcon } from 'uitk-react-icons';
import { useLocalization } from '@shared-ui/localization-context';
import styles from './uitk-action-list-item.css';
import { UitkActionListItemSpacings } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var ActionListItem = function (props) {
  var _a;
  var active = props.active,
    borderSeparator = props.borderSeparator,
    className = props.className,
    disabled = props.disabled,
    children = props.children,
    selected = props.selected,
    spacing = props.spacing,
    l10n = props.l10n,
    attr = __rest(props, ["active", "borderSeparator", "className", "disabled", "children", "selected", "spacing", "l10n"]);
  var spacingType = spacing && UitkActionListItemSpacings.get(spacing);
  var ariaDesc = selected ? l10n.formatText('selected') : '';
  var baseCssClass = 'uitk-action-list-item';
  var cssClassNames = getClassNameList(baseCssClass, className, (_a = {}, _a["".concat(baseCssClass, "-selected")] = selected, _a["".concat(baseCssClass, "-active")] = active, _a["".concat(baseCssClass, "-disabled")] = disabled, _a["".concat(baseCssClass, "-").concat(spacingType)] = spacingType, _a["".concat(baseCssClass, "-border")] = borderSeparator, _a));
  return React.createElement(UitkContextProvider, {
    config: {
      context: null,
      data: {
        contextAriaDesc: ariaDesc
      }
    }
  }, React.createElement("li", __assign({
    className: cssClassNames
  }, attr), React.createElement("div", {
    className: getClassNameList('uitk-action-list-item-content')
  }, children), selected && React.createElement(UitkIcon, {
    className: getClassNameList('uitk-action-list-item-check'),
    name: "check"
  })));
};
var UitkActionListItem = function (props) {
  var l10n = useLocalization();
  return React.createElement(ActionListItem, __assign({
    l10n: l10n
  }, props));
};
UitkActionListItem.defaultProps = {
  spacing: 'standard'
};
UitkActionListItem.displayName = 'UitkActionListItem';
export { ActionListItem, UitkActionListItem };